import script from "./ClientPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientPage.vue?vue&type=script&setup=true&lang=js"

import "./ClientPage.vue?vue&type=style&index=0&id=3d0376be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0376be"]])

export default __exports__